document.addEventListener('DOMContentLoaded', function () {
    let toggles = document.querySelectorAll('.js-item-toggle');
    let toggleClick = (activeToggle) => {
        toggles.forEach((toggle) => {
            if(activeToggle == toggle) {
                toggle.ariaExpanded = 'true';
                // toggle.parentElement.style.cursor = 'inherit';
                toggle.parentElement.classList.add('portfolio-item--active');

                // This wasn't working... maybe next time
                // toggle.parentElement.scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'start'
                // });
            } else {
                toggle.ariaExpanded = 'false';
                // toggle.parentElement.style.cursor = 'var(--cursor-pointer)';
                toggle.parentElement.classList.remove('portfolio-item--active');
            }
        });
    }

    toggles.forEach((toggle) => {
        // Enable parent container click
        // toggle.parentElement.style.cursor = 'var(--cursor-pointer)';
        toggle.parentElement.addEventListener('click', (e) => {
            if(!toggle.parentElement.classList.contains('portfolio-item--active')) {
                e.preventDefault();
                toggleClick(toggle);
            }
        });

        // Enable arrow container click
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            toggleClick(toggle);
        });
    });

    //If the first toggle exists, set it to active
    if(toggles.length > 0 && window.innerWidth > 475) {
        setTimeout(() => {
            toggles[0].click();
        }, 500);
    }
});
